import React from "react";
import product from "../../assets/Product.png";
import "./product.css";

const Product = () => {
  return (
    <section className="product">
      <img src={product} alt="product" className="product-img" />

      <div className="product-content">
        <h2 className="product-title">Product</h2>
        <p className="product-description">
          DanteGPU consists of two core marketplaces: an AI Agent Marketplace
          and a GPU Renting Marketplace. What makes DanteGPU unique is the
          integration of its own AI agent, Dantian AI, which optimizes usage by
          recommending the best AI agent-GPU matches. Users are free to manually
          choose GPUs, but the system provides optimized recommendations for
          better performance.
        </p>
      </div>
    </section>
  );
};

export default Product;
